import { TabContext, TabPanel } from "@mui/lab";
import { Box, Tab, TableContainer, Tabs } from "@mui/material";
import { useState } from "react";
import InfoSettings from "./Info";
import FeesCalculatorInfoSettings from "./FeesCalculatorInfoSettings";
import MobileAppsliderText from "./MobileAppSilderText";
import VideoVerificationQuestions from "./VideoVerificationQuestions";
import SubjectsSetting from "./SubjectsSetting";
import CACPackageSettings from "./CAC-packageSettings";
import ParentShadowWalletRechargePackSettings from "./ParentShadowWalletRechargePackSettings";
import ChatAndCallPackageSettings from "./ChatAndCallPackageSettings";
import FaqSettings from "./FaqSettings";

const InfoSettingTabs = () => {
  const [trialClassTab, setTrialClassTab] = useState("1");

  const handleTeacherSubTabChange = (event, newValue) => {
    setTrialClassTab(newValue);
  };
  return (
    <div className="max-w-[100vw] overflow-x-hidden">
      <div className="title text-yellow-500 text-xl">Info settings</div>
      <div className="">
        <TabContext value={trialClassTab}>
          <Box
            className="mb-3"
            sx={{
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <Tabs
              onChange={handleTeacherSubTabChange}
              aria-label="Teacher subtabs"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                // Firefox
                "&::-webkit-scrollbar": {
                  height: "6px", // horizontal scrollbar thickness
                  color: "var(--color-light-gray)",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "rgba(0,0,0,0.3)",
                  borderRadius: "3px",
                  color: "var(--color-light-gray)",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent",
                  color: "var(--color-light-gray)",
                },
                "& .MuiSvgIcon-root": {
                  fill: "white",
                  fontSize: "2.25rem",
                },

                "& .MuiTab-root": {
                  flexShrink: 0, // prevent shrinking
                  color: "var(--color-light-gray)",
                  "&:hover": {
                    color: "var(--color-primary)!important",
                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px 8px 0 0",
                  },
                },
                "& .Mui-selected": {
                  color: "var(--color-primary)!important",
                  backgroundColor: "rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  borderRadius: "8px 8px 0 0",
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "var(--color-primary)",
                },
              }}
            >
              <Tab label="Info settings" value="1" />
              <Tab label="Fees calculator settings" value="2" />
              <Tab
                label="Mobile app slider text (Parent / Teacher)"
                value="3"
              />
              <Tab label="Video verification settings" value="4" />
              <Tab label="Subjects settings" value="5" />
              <Tab label="Contact access coin package settings" value="6" />
              <Tab
                label="Parent shadow wallet recharge pack settings"
                value="7"
              />
              <Tab label="Chat and call package settings" value="8" />
              <Tab label="FAQ settings" value="9" />
            </Tabs>
          </Box>
          <TabPanel value="1">
            <TableContainer>
              <InfoSettings />
            </TableContainer>
          </TabPanel>
          <TabPanel value="2">
            <TableContainer>
              <FeesCalculatorInfoSettings />
            </TableContainer>
          </TabPanel>
          <TabPanel value="3">
            <TableContainer>
              <MobileAppsliderText />
            </TableContainer>
          </TabPanel>
          <TabPanel value="4">
            <TableContainer>
              <VideoVerificationQuestions />
            </TableContainer>
          </TabPanel>
          <TabPanel value="5">
            <TableContainer>
              <SubjectsSetting />
            </TableContainer>
          </TabPanel>
          <TabPanel value="6">
            <TableContainer>
              <CACPackageSettings />
            </TableContainer>
          </TabPanel>
          <TabPanel value="7">
            <TableContainer>
              <ParentShadowWalletRechargePackSettings />
            </TableContainer>
          </TabPanel>
          <TabPanel value="8">
            <TableContainer>
              <ChatAndCallPackageSettings />
            </TableContainer>
          </TabPanel>
          <TabPanel value="9">
            <TableContainer>
              <FaqSettings />
            </TableContainer>
          </TabPanel>
        </TabContext>
      </div>
    </div>
  );
};

export default InfoSettingTabs;
